export const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const GET_EVENTS_FAIL = 'GET_EVENTS_FAIL';
export function getEventsRequest(data) {
  return {
    type: GET_EVENTS_REQUEST,
    payload: data,
  };
}
